// extracted by mini-css-extract-plugin
export default {"root":"root__SduZ7","fadeInAnimation":"fadeInAnimation__i2iKN","attendanceTitle":"attendanceTitle__fB2t1"};